import React, { useState } from "react";
import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";
import './AuthPage.css';

const AuthPage = ({ setUser, handleLoginSuccess }) => {
  const [isSignUp, setIsSignUp] = useState(false);

  return (
    <div className="auth-page-wrapper">

      {/* ====================== */}
      {/* DESKTOP / TABLET VIEW  */}
      {/* ====================== */}
      <div className="auth-desktop">
        <div className={`auth-container ${isSignUp ? 'right-panel-active' : ''}`} id="container">
          {/* SIGN UP FORM */}
          <SignUpForm
            setIsSignUp={setIsSignUp}
            setUser={setUser}
            handleLoginSuccess={handleLoginSuccess}
          />

          {/* SIGN IN FORM */}
          <SignInForm
            handleLoginSuccess={handleLoginSuccess}
          />

          {/* Overlay panels - only visible on desktop */}
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>Welcome Back!</h1>
                <p>To keep connected with us please login with your personal info</p>
                <button className="ghost" onClick={() => setIsSignUp(false)}>
                  Sign In
                </button>
              </div>
              <div className="overlay-panel overlay-right">
                <h1>Hello, Friend!</h1>
                <p>Enter your personal details and start your journey with us</p>
                <button className="ghost" onClick={() => setIsSignUp(true)}>
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ====================== */}
      {/*    MOBILE VIEW        */}
      {/* ====================== */}
      <div className="auth-mobile">
        <div className="mobile-form-wrapper">
          {isSignUp ? (
            <SignUpForm
              setIsSignUp={setIsSignUp}
              setUser={setUser}
              handleLoginSuccess={handleLoginSuccess}
            />
          ) : (
            <SignInForm
              handleLoginSuccess={handleLoginSuccess}
            />
          )}
        </div>

        {/* Toggle text at the bottom */}
        <div className="mobile-auth-toggle">
          {isSignUp ? (
            <p>
              Already have an account?{" "}
              <button
                type="button"
                className="text-toggle-btn"
                onClick={() => setIsSignUp(false)}
              >
                Sign In
              </button>
            </p>
          ) : (
            <p>
              Don't have an account?{" "}
              <button
                type="button"
                className="text-toggle-btn"
                onClick={() => setIsSignUp(true)}
              >
                Sign Up
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;